/* The five-question chooser, ported from lib/keuzehulp.ts.

   Five flat questions rather than a branching tree. A tree asks fewer
   questions, but the visitor cannot go back and change an early answer without
   losing the later ones, and every branch is a separate path to test. Flat
   questions keep every answer in the URL.

   Questions that do not apply to the first answer are skipped — see appliesTo.
   Before `doel` is answered every step is assumed to apply, so the counter
   starts at "1 van 5" and can shrink to "van 3". Counting up as you go
   ("1 van 3" then "2 van 5") reads like the form is growing under you. */
(function () {
  'use strict';
  var root = document.querySelector('[data-aw-kh]');
  if (!root) return;
  var mount = root.querySelector('[data-aw-kh-mount]');
  var cfgEl = document.querySelector('[data-aw-kh-config]');
  var CFG = {};
  try {
    CFG = JSON.parse(cfgEl.textContent);
  } catch (e) {
    // Failing silently here is how a malformed config block turned into a
    // blank page with no clue. Say what happened.
    console.error('[aw-keuzehulp] config is not valid JSON:', e);
    return;
  }
  var P = CFG.products || {};
  var R = CFG.reading || {};
  var BASE = CFG.basePath || window.location.pathname;

  var STEPS = [
    { key: 'doel', question: 'Wat wil je afsluiten, afschermen of vervangen?',
      help: 'Kies wat het dichtst in de buurt komt. Heb je meerdere dingen nodig, kies dan de grootste.',
      choices: [
        { value: 'terrein', title: 'Een terrein, oprit of tuin', sub: 'Een poort, een hek, of allebei' },
        { value: 'garage', title: 'Een garage, schuur of carport', sub: 'Bij een woning' },
        { value: 'bedrijf', title: 'Een bedrijfspand, loods of magazijn', sub: 'Industriële deuren, vaak op maat' },
        { value: 'gevel', title: 'Een gevelopening: deur, raam of kozijn', sub: 'Voordeur, achterdeur, kozijnen, schuifpui' } ] },
    { key: 'gebouw', question: 'Om wat voor gebouw gaat het?',
      choices: [
        { value: 'bestaand', title: 'Bestaande woning', sub: 'Renovatie of vervanging' },
        { value: 'nieuwbouw', title: 'Nieuwbouw of aanbouw', sub: 'Nog in aanbouw of net opgeleverd' },
        { value: 'zakelijk', title: 'Bedrijfspand of instelling' },
        { value: 'onbekend', title: 'Weet ik nog niet' } ] },
    { key: 'opening', question: 'Hoe breed is de opening ongeveer?',
      help: 'Een schatting is genoeg. De exacte maat komt bij het inmeten.',
      appliesTo: ['terrein', 'garage', 'bedrijf'],
      choices: [
        { value: 'smal', title: 'Tot 3 meter', sub: 'Eén auto, of een looppoort' },
        { value: 'middel', title: '3 tot 5 meter', sub: 'Brede oprit of dubbele garage' },
        { value: 'breed', title: 'Meer dan 5 meter', sub: 'Vaak zakelijk of projectmatig' },
        { value: 'onbekend', title: 'Weet ik niet' } ] },
    { key: 'bediening', question: 'Hoe wil je het bedienen?',
      appliesTo: ['terrein', 'garage', 'bedrijf'],
      choices: [
        { value: 'elektrisch', title: 'Elektrisch', sub: 'Afstandsbediening, code of app' },
        { value: 'hand', title: 'Met de hand', sub: 'Geen aandrijving nodig' },
        { value: 'onbekend', title: 'Weet ik nog niet' } ] },
    { key: 'montage', question: 'Wie plaatst het?',
      help: 'Dit bepaalt vooral of je bij een dealer of bij ons rechtstreeks moet zijn.',
      choices: [
        { value: 'dealer', title: 'Liefst één partij die alles regelt', sub: 'Advies, inmeten, leveren en monteren' },
        { value: 'aw', title: 'Graag door AW zelf', sub: 'Ons eigen montageteam' },
        { value: 'zelf', title: 'Ik plaats het zelf', sub: 'Of mijn eigen aannemer doet dat' },
        { value: 'onbekend', title: 'Weet ik nog niet' } ] }
  ];

  function answersFromUrl() {
    var q = new URLSearchParams(window.location.search);
    var a = {};
    STEPS.forEach(function (s) {
      var v = q.get(s.key);
      /* Only accept values the step actually offers — a hand-edited query
         string should not be able to put the flow into a state the code does
         not expect. */
      if (v && s.choices.some(function (c) { return c.value === v; })) a[s.key] = v;
    });
    /* An answer to a question this visitor never saw (because of appliesTo)
       would otherwise linger in the URL and skew the result. */
    var visible = {};
    activeSteps(a).forEach(function (s) { visible[s.key] = true; });
    Object.keys(a).forEach(function (k) { if (!visible[k]) delete a[k]; });
    return a;
  }
  function activeSteps(a) {
    return STEPS.filter(function (s) { return !s.appliesTo || !a.doel || s.appliesTo.indexOf(a.doel) !== -1; });
  }
  function nextStep(a) {
    var found = null;
    activeSteps(a).some(function (s) { if (!a[s.key]) { found = s; return true; } return false; });
    return found;
  }
  function labelFor(key, value) {
    var s = null, out = null;
    STEPS.forEach(function (x) { if (x.key === key) s = x; });
    if (s) s.choices.forEach(function (c) { if (c.value === value) out = c.title; });
    return out;
  }
  function answeredKeys(a) {
    return activeSteps(a).filter(function (s) { return a[s.key]; }).map(function (s) { return s.key; });
  }
  function qs(a, keys) {
    var p = new URLSearchParams();
    keys.forEach(function (k) { p.set(k, a[k]); });
    var s = p.toString();
    return s ? BASE + '?' + s : BASE;
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function host(url) { try { return new URL(url).hostname.replace(/^www\./, ''); } catch (e) { return url; } }

  /* ---------------------------------------------------------- recommendation */
  function recommend(a) {
    var reasoning = [], primary, secondary, reading, headline;

    if (a.doel === 'gevel') {
      /* Aluminium vs PVC is the one place where the answer genuinely turns on
         the building. Both are ours, so there is no thumb on the scale. */
      var nieuw = a.gebouw === 'nieuwbouw';
      primary = nieuw ? P.aluminium : P.kunststof;
      secondary = {
        product: nieuw ? P.kunststof : P.aluminium,
        because: nieuw
          ? 'Goedkoper in aanschaf en bij gelijke opbouw iets beter isolerend — het overwegen waard als het budget leidend is.'
          : 'Slankere profielen en een langere levensduur. Meerprijs, maar bij grote glasvlakken vaak de betere keuze.'
      };
      headline = nieuw
        ? 'Aluminium kozijnen liggen bij nieuwbouw het meest voor de hand'
        : 'Kunststof kozijnen passen het beste bij vervanging in bestaande bouw';
      reasoning.push(nieuw
        ? 'Bij nieuwbouw ligt de gevelopening nog niet vast, dus je kunt de slankere aluminium profielen en grotere glasvlakken benutten.'
        : 'Bij vervanging in een bestaande gevel is de opening gegeven. Kunststof is dan doorgaans de gunstigste verhouding tussen prijs en prestatie.');
      reading = R.kozijnen;

    } else if (a.doel === 'bedrijf' || a.gebouw === 'zakelijk') {
      primary = P.bedrijfsdeuren;
      secondary = { product: P.hekwerken,
        because: 'Bedrijfspanden hebben naast de deur bijna altijd terreinafsluiting nodig. In één offerte scheelt dat een tweede traject.' };
      headline = 'Industriële bedrijfsdeuren';
      reasoning.push('Voor een bedrijfspand, loods of magazijn gaat het om industriële sectionaal-, rol- of schuifdeuren. Die worden op maat gemaakt en projectmatig geleverd.');
      reading = R.deuren;

    } else if (a.doel === 'garage') {
      primary = P.garagedeuren;
      headline = 'Een garagedeur';
      reasoning.push('Voor een garage, schuur of carport bij een woning kom je uit bij sectionaal-, kantel-, rol- of openslaande deuren.');
      if (a.opening === 'breed') {
        reasoning.push('Bij meer dan 5 meter breedte wordt een sectionaaldeur met dubbele geleiding of een industriële uitvoering realistischer dan een standaard garagedeur — daar kijken we bij het inmeten naar.');
        secondary = { product: P.bedrijfsdeuren,
          because: 'Vanaf ongeveer 5 meter zit je in het formaat waar de industriële serie vaak beter en goedkoper uitpakt.' };
      }
      reading = R.deuren;

    } else {
      primary = P.hekwerken;
      headline = 'Een poort of hekwerk';
      reasoning.push('Voor het afsluiten van een terrein, oprit of tuin kom je uit bij een schuif-, draai- of vouwpoort, meestal gecombineerd met hekwerk en een looppoort.');
      if (a.opening === 'smal') {
        reasoning.push('Bij een opening tot 3 meter is een draaipoort meestal de eenvoudigste en goedkoopste oplossing — mits er ruimte is om open te draaien.');
      } else if (a.opening === 'middel' || a.opening === 'breed') {
        reasoning.push('Vanaf ongeveer 3 meter wordt een schuifpoort interessanter: die heeft geen draaicirkel nodig en is bij grotere breedtes stabieler.');
      }
      reading = R.poort;
    }

    if (a.bediening === 'elektrisch') {
      reasoning.push('Met elektrische bediening komt er een aandrijving, een voeding en meestal een veiligheidsbeveiliging bij. Laat dat meenemen in de offerte in plaats van het achteraf toe te voegen — achteraf is het altijd duurder.');
    }

    var route;
    if (a.montage === 'zelf') {
      route = { title: 'Bestel rechtstreeks bij ons',
        body: 'Plaats je zelf, dan heb je geen dealer nodig. Wij leveren uit voorraad in Nieuw Heeten en geven de technische ondersteuning erbij. Let op dat je de maten laat kloppen: bij zelfmontage ligt het inmeten bij jou.',
        cta: 'Vraag een offerte aan', href: CFG.offerteUrl };
    } else if (a.montage === 'aw') {
      route = { title: 'Wij komen zelf',
        body: 'Ons eigen montageteam werkt door heel Nederland. Vraag een offerte aan; we nemen contact op om in te meten en een datum te plannen.',
        cta: 'Vraag een offerte aan', href: CFG.offerteUrl };
    } else {
      route = { title: 'Ga naar een dealer bij jou in de buurt',
        body: 'Wil je één partij die adviseert, inmeet, levert én monteert, dan is een dealer meestal de snelste route. Zij kennen de regio en verzorgen ook de nazorg.',
        cta: 'Zoek een dealer', href: CFG.dealersUrl };
    }

    return { primary: primary, secondary: secondary, headline: headline,
             reasoning: reasoning, route: route, reading: reading };
  }

  /* ---------------------------------------------------------------- rendering */
  var ARROW = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" class="btn__arrow"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var CHECK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m4 12 5 5L20 6"/></svg>';

  function recapList(a, wide) {
    var keys = answeredKeys(a);
    if (!keys.length) return '';
    var rows = keys.map(function (k) {
      var s = null;
      STEPS.forEach(function (x) { if (x.key === k) s = x; });
      return '<div><dt>' + esc(s.question) + '</dt><dd>' + esc(labelFor(k, a[k])) + '</dd></div>';
    }).join('');
    return '<dl class="kh__recap-list' + (wide ? ' kh__recap-list--wide' : '') + '">' + rows + '</dl>';
  }

  function renderQuestion(a, step) {
    var steps = activeSteps(a);
    var index = 0;
    steps.forEach(function (s, i) { if (s.key === step.key) index = i + 1; });
    var total = steps.length;
    var keys = answeredKeys(a);

    var radios = step.choices.map(function (c) {
      return '<label class="radio"><input type="radio" name="' + step.key + '" value="' + esc(c.value) + '">' +
        '<span class="radio__box"><span class="radio__dot" aria-hidden="true"></span>' +
        '<span class="radio__text"><span class="radio__title">' + esc(c.title) + '</span>' +
        (c.sub ? '<span class="radio__sub">' + esc(c.sub) + '</span>' : '') +
        '</span></span></label>';
    }).join('');

    mount.className = 'container kh__inner';
    mount.innerHTML =
      '<div>' +
        '<div class="kh__progress">' +
          '<p class="kh__count">Vraag ' + index + ' van ' + total + '</p>' +
          '<div class="kh__bar" aria-hidden="true"><span style="inline-size:' + ((index / total) * 100) + '%"></span></div>' +
        '</div>' +
        '<form class="kh__form" data-kh-form>' +
          '<h2 class="kh__question">' + esc(step.question) + '</h2>' +
          (step.help ? '<p class="kh__help">' + esc(step.help) + '</p>' : '') +
          '<div class="radios">' + radios + '</div>' +
          '<div class="kh__actions">' +
            '<button class="btn btn--primary" type="submit">Volgende' + ARROW + '</button>' +
            (index > 1 ? '<a class="btn btn--ghost" href="' + esc(qs(a, keys.slice(0, -1))) + '" data-kh-back>Vorige vraag</a>' : '') +
          '</div>' +
        '</form>' +
      '</div>' +
      '<aside class="kh__aside">' +
        (keys.length ? '<div class="kh__recap"><p class="faq__aside-title">Je antwoorden</p>' + recapList(a) + '</div>' : '') +
        '<div class="kh__skip">' +
          '<p class="faq__aside-title">Liever meteen iemand spreken?</p>' +
          '<p class="faq__aside-text">Bellen gaat vaak sneller dan invullen. Je krijgt iemand die het assortiment kent.</p>' +
          '<a class="faq__aside-tel" href="tel:' + esc(CFG.phoneHref) + '">' + esc(CFG.phone) + '</a>' +
        '</div>' +
      '</aside>';

    mount.querySelector('[data-kh-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var picked = mount.querySelector('input[name="' + step.key + '"]:checked');
      if (!picked) return;
      var next = Object.assign({}, a);
      next[step.key] = picked.value;
      go(qs(next, answeredKeys(next)));
    });
    var back = mount.querySelector('[data-kh-back]');
    if (back) back.addEventListener('click', function (e) { e.preventDefault(); go(back.getAttribute('href')); });
  }

  function renderResult(a) {
    var r = recommend(a);
    if (!r.primary) { mount.innerHTML = '<p class="lede">Er ging iets mis bij het samenstellen van het advies.</p>'; return; }
    var h = host(r.primary.href);

    var why = r.reasoning.map(function (l) {
      return '<li>' + CHECK + '<span>' + esc(l) + '</span></li>';
    }).join('');

    mount.className = 'container';
    mount.innerHTML =
      '<div class="post__answer" style="max-width:78ch">' +
        '<p class="post__answer-label">Onze suggestie</p><p>' + esc(r.headline) + '.</p>' +
      '</div>' +
      '<div class="khresult">' +
        '<article class="khresult__main">' +
          '<span class="khresult__media"><img src="' + esc(r.primary.img) + '" alt="' + esc(r.primary.alt) + '" width="1200" height="800"></span>' +
          '<div class="khresult__body">' +
            '<p class="eyebrow">Aanbevolen productgroep</p>' +
            '<h2 class="khresult__title">' + esc(r.primary.title) + '</h2>' +
            '<p class="khresult__sub">' + esc(r.primary.sub) + '</p>' +
            '<ul class="khresult__why">' + why + '</ul>' +
            '<div class="hero__actions" style="margin-top:var(--sp-8)">' +
              '<a class="btn btn--primary" href="' + esc(r.primary.href) + '" target="_blank" rel="noopener">Bekijk het aanbod op ' + esc(h) + ARROW + '</a>' +
            '</div>' +
          '</div>' +
        '</article>' +
        '<aside class="khresult__side">' +
          '<div class="khresult__card">' +
            '<p class="faq__aside-title">' + esc(r.route.title) + '</p>' +
            '<p class="faq__aside-text">' + esc(r.route.body) + '</p>' +
            '<a class="btn btn--primary btn--block" href="' + esc(r.route.href) + '">' + esc(r.route.cta) + ARROW + '</a>' +
          '</div>' +
          (r.secondary && r.secondary.product ?
          '<div class="khresult__card">' +
            '<p class="faq__aside-title">Ook overwegen: ' + esc(r.secondary.product.title.toLowerCase()) + '</p>' +
            '<p class="faq__aside-text">' + esc(r.secondary.because) + '</p>' +
            '<a class="faq__aside-link" href="' + esc(r.secondary.product.href) + '" target="_blank" rel="noopener">Bekijk deze groep' + ARROW + '</a>' +
          '</div>' : '') +
          (r.reading ?
          '<div class="khresult__card">' +
            '<p class="faq__aside-title">Verder lezen</p>' +
            '<p class="faq__aside-text">De afweging waar je nu waarschijnlijk voor staat, uitgeschreven zonder verkooppraatje.</p>' +
            '<a class="faq__aside-link" href="' + esc(r.reading.href) + '">' + esc(r.reading.title) + ARROW + '</a>' +
          '</div>' : '') +
        '</aside>' +
      '</div>' +
      '<div class="kh-recap" style="margin-top:var(--sp-16)">' +
        '<p class="eyebrow">Op basis van</p><h2 class="section-title">Je antwoorden</h2>' +
        recapList(a, true) +
        '<div class="hero__actions" style="margin-top:var(--sp-8)">' +
          '<a class="btn btn--ghost" href="' + esc(BASE) + '" data-kh-restart>Opnieuw beginnen</a>' +
          '<a class="btn btn--ghost" href="tel:' + esc(CFG.phoneHref) + '">' + esc(CFG.phone) + '</a>' +
        '</div>' +
      '</div>';

    var restart = mount.querySelector('[data-kh-restart]');
    if (restart) restart.addEventListener('click', function (e) { e.preventDefault(); go(BASE); });
  }

  function go(url) {
    window.history.pushState({}, '', url);
    render();
  }

  function render() {
    var a = answersFromUrl();
    var step = nextStep(a);
    if (step) renderQuestion(a, step); else renderResult(a);
    root.hidden = false;
  }

  window.addEventListener('popstate', render);
  render();
})();
